module.exports = __webpack_public_path__ + "media/assets/images/category/FathersDay@2x-75e43161130bfa9a7d700fc8197e1b8f.png";